import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { IoCart } from "react-icons/io5";
import Offer from './Offer';
import Logout from './Logout';
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';

import logo from '../assets/logo.png'
import { createStore } from '../store/state';
import { getCartNumber } from '../features/cartSlice';
import { offerStatus } from '../features/offerSlice';

export default function Header() {
    const [isActive, setIsActive] = useState(false);

    const navigate = useNavigate()
    const cartNumber = useSelector(getCartNumber)
    const offer = useSelector(offerStatus);

    const { user } = createStore((state) => state)

    const headerStyle = offer ? "offer" : ""

    return (
        <>
            {isActive && <div onClick={() => setIsActive((action) => !action)} className='trans-bg'></div>}
            {offer && <Offer />}
            <header className={headerStyle}>
                <Link to="/" className='logo'><img src={logo} alt='logo' /></Link>
                <div className='header-right'>
                    <IconButton color="grey" aria-label="add to shopping cart" onClick={() => navigate('/cart')}>
                        <IoCart />
                        <span className='cart-count'>{cartNumber}</span>
                    </IconButton>
                    {user
                        ? <Logout />
                        : <Button onClick={() => navigate('/login')} variant="contained" size='small'>
                            Login
                        </Button>}
                </div>
            </header>
        </>
    )
}
